import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createMigrate, persistStore, persistReducer } from 'redux-persist';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import storage from 'redux-persist/lib/storage';
import reducers from '../reducers';

const migrations = {
  1: state => {
    return { ...state };
  },
  2: state => {
    return { ...state };
  },
};

const persistConfig = {
  key: 'root',
  timeout: 10000,
  storage,
  whitelist: ['auth'],
  transforms: [
    encryptTransform({
      secretKey: 'QUA-MENSERV-SECRET',
      onError: function (error) {
        console.log(error);
      },
    }),
  ],
  version: 3,
  migrate: createMigrate(migrations, { debug: true }),
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const persistedReducer = persistReducer(persistConfig, reducers);
const store = createStore(persistedReducer, {}, composeEnhancers(applyMiddleware(thunk)));
const persistor = persistStore(store);

export { store, persistor };
